import { render } from "./EmployeeSalary.vue?vue&type=template&id=cbe1ce7e&scoped=true"
import script from "./EmployeeSalary.vue?vue&type=script&lang=js"
export * from "./EmployeeSalary.vue?vue&type=script&lang=js"

import "./EmployeeSalary.vue?vue&type=style&index=0&id=cbe1ce7e&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe1ce7e"]])

export default __exports__